import { FooterPadrao } from "./styled";

//PROPS
interface Props {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const Footer: React.FC<Props> = ({ children, style }) => {
    return (
        <FooterPadrao style={style}>
            {children}
        </FooterPadrao>
    )
};

export default Footer;